import { Injectable } from '@angular/core';
import Swal from 'sweetalert2';

@Injectable({
  providedIn: 'root'
})
export class SwalService {
  private defaultConfig = {
    heightAuto: false
  };

  constructor() { }

  async error(msg: string, isHtml: boolean = false) {
    await Swal.fire({
      ...this.defaultConfig,
      title: 'Error',
      [isHtml ? 'html' : 'text']: msg,
      icon: 'error'
    });
  }

  async success(msg: string, isHtml: boolean = false) {
    await Swal.fire({
      ...this.defaultConfig,
      title: 'Exitoso',
      [isHtml ? 'html' : 'text']: msg,
      icon: 'success'
    });
  }
  
  async warning(msg: string, isHtml: boolean = false) {
    await Swal.fire({ 
      ...this.defaultConfig,
      [isHtml ? 'html' : 'text']: msg,
      icon: 'warning'
    });
  }
  
  async success_timer(msg: string, isHtml: boolean = false) {
    await Swal.fire({
      ...this.defaultConfig,
      title: 'Exitoso',
      [isHtml ? 'html' : 'text']: msg,
      icon: 'success',
      timer: 1000,
      showConfirmButton: false
    });
  }
}
